/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useMemo } from 'react'
import NoResults from '@/components/messages/NoResults'
import Pagination from '@/components/listing-sort-filtering/Pagination'
import { Box } from '@chakra-ui/react'

const ItemsPagination = ({
  children,
  currentPage,
  footer,
  header,
  onChangePage,
  searchParams = {},
  showCounter = true,
  textNoItems,
  textSearchParamsNoItems,
  totalItems,
  totalPages
}) => {
  const searchParamsKeys = Object.keys(searchParams)
  const hasPagination = useMemo(() =>
    Boolean(totalItems && totalItems > 0 && currentPage && onChangePage && totalPages && totalPages > 1),
  [totalItems, currentPage, onChangePage, totalPages])

  if (!searchParamsKeys.length && !totalItems) {
    return <NoResults text={textNoItems}/>
  }

  return (
    <>
      { header &&
        <Box className="mb-6">
          { header }
        </Box>
      }
      { totalItems
        ? <Box className="mb-6">
            { children }
          </Box>
        : <NoResults
            text={textSearchParamsNoItems}
          />
      }
      { hasPagination &&
        <Pagination
          currentPage={currentPage}
          onChangePage={onChangePage}
          showCounter={showCounter}
          totalItems={totalItems}
          totalPages={totalPages}
        />
      }
      { footer }
    </>
  )
}

export default ItemsPagination
